export default __webpack_public_path__ + "static/media/logo-round.02fb55da.svg";